function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // Heavily inspired by https://stackoverflow.com/a/61923286/4413709


import { useMemo, useRef, useState } from 'react';

var enhanceDispatch = function enhanceDispatch(_ref) {
  var getState = _ref.getState,
      stateDispatch = _ref.stateDispatch;
  return function () {
    var _dispatch;

    var middlewareAPI = {
      getState: getState,
      dispatch: function dispatch(action) {
        return _dispatch(action);
      }
    };

    for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
      middlewares[_key] = arguments[_key];
    }

    _dispatch = middlewares.map(function (m) {
      return m(middlewareAPI);
    }).reduceRight(function (next, mw) {
      return mw(next);
    }, stateDispatch);
    return _dispatch;
  };
};

export var useMiddlewareReducer = function useMiddlewareReducer(middlewares, reducer, initialState) {
  var initializer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (s) {
    return s;
  };

  var _useState = useState(initializer(initialState)),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var stateRef = useRef(state);
  var dispatch = useMemo(function () {
    return enhanceDispatch({
      getState: function getState() {
        return stateRef.current;
      },
      stateDispatch: function stateDispatch(action) {
        stateRef.current = reducer(stateRef.current, action);
        setState(stateRef.current);
        return action;
      }
    }).apply(void 0, _toConsumableArray(middlewares));
  }, [middlewares, reducer]);
  return [state, dispatch];
};